import { ApiEndpoints } from "../models/ApiEndpoints";

import { RoleTag, UpdateUserTagRequest } from "../models/Role";
import { TagCollection } from "../models/TagCollection";
import { ApiMethods } from "../models/ApiMethods";
import {
  ApiGetHook,
  ApiMutateHook,
  useApiGet,
  useApiMutate,
} from "@skanska/vsa-client-auth";
import { ContactPersons } from "../models/UserInformation";
import { CacheKeys } from "../constants/CacheKeys";

export function useRoleTagCollectionGet(): ApiGetHook<TagCollection[]> {
  return useApiGet<TagCollection[]>(ApiEndpoints.Roles);
}

export function useTagsWithRole(
  tagCollectionId: string
): ApiGetHook<RoleTag[]> {
  return useApiGet<RoleTag[]>(
    ApiEndpoints.Roles,
    tagCollectionId,
    `roles-${tagCollectionId}`
  );
}

export function useUpdateRoleTags(
  tagCollectionId: string
): ApiMutateHook<void, UpdateUserTagRequest> {
  return useApiMutate<void, UpdateUserTagRequest>(
    ApiEndpoints.RolesUpdate,
    ApiMethods.Post,
    tagCollectionId,
    null,
    [
      `roles-${tagCollectionId}`,
      CacheKeys.Activity.ActivityList,
      CacheKeys.Activity.SingleActivity,
    ]
  );
}

export function useGetRole(
  tagCollectionId: string,
  tagId: string
): ApiGetHook<ContactPersons> {
  const tagRoute = tagCollectionId + "/" + tagId;
  return useApiGet<ContactPersons>(ApiEndpoints.RolesPerson, tagRoute);
}
